import { Component, Input } from '@angular/core';
import { IWhereMyMoney } from '@bp-core/src/lib/models/portal/goal/whereMyMoney.model';
import { environment } from '@environment/environment';
import { ColorService } from 'bp/shared/services/color.service';
import { DecimalPipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    selector: 'bp-funds-resume',
    templateUrl: './bp-funds-resume.component.html',
    styleUrls: ['./bp-funds-resume.component.scss'],
    standalone: true,
    imports: [
        MatExpansionModule,
        MatDividerModule,
        MatIconModule,
        MatTooltipModule,
        DecimalPipe,
    ],
})
export class BpFundsResumeComponent {
  urlFileBase = environment.urlApiV2 + 'api/Files/';
  token = localStorage.getItem('access_token');

  @Input() fundsArray: IWhereMyMoney[];
  @Input() box: IWhereMyMoney;
  @Input() showBox = true;
  @Input() isCustom = false;

  constructor(private colorService: ColorService) {}

  getFeaturesSplit(feature: string, index: number) {
    let splitfeatures: string[] = [];
    try {
      if (feature.split(':').length > 1) {
        splitfeatures = feature.split(':');
      } else {
        splitfeatures.push(feature);
        splitfeatures.push('');
      }
    } catch (error) {
      console.log('getFeaturesSplit', error);
    }

    try {
      return splitfeatures[index];
    } catch (error) {
      return '';
    }
  }

  getLightColor(color: string) {
    return this.colorService.getLightColor(color, 0.5);
  }
}
